export default "__VITE_ASSET__9f779b90__"